module.exports = __webpack_public_path__ + "assets/apple-icon-72x72.5cc5f366.png";